<div class="container-fluid px-0 bg-star">
<div class="container py-5">
    <div class="row">
        <div class="col-md-8 col-lg-6 m-auto">
            <div class="signup-form">
                <h5 class="mb-4">Sign Up as a Coach</h5>
                <form [formGroup]="coachForm" (ngSubmit)="onSigup(coachForm)">
                    <div class="form-group">
                        <label for="emailInput" class="form-label">Your Email address</label>
                        <input type="email" class="form-control" formControlName="email" id="emailInput">
                        <div class="invalid-feedback d-block"
                            *ngIf="(f1['email'].errors?.['required'] || f1['email'].errors?.['email']) && (f1['email'].dirty || f1['email'].touched)">
                            Please fill valid email.
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="" class="form-label">Create Password:</label>
                        <input type="password" class="form-control" formControlName="password">
                        <div class="invalid-feedback d-block"
                            *ngIf="(f1['password'].errors?.['required'] || f1['password'].errors?.['minlength']) && (f1['password'].dirty || f1['password'].touched)">
                            Please fill 8 character long password.
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="" class="form-label">Re-Enter Password:</label>
                        <input type="password" class="form-control" formControlName="re_password">
                        
                        <div *ngIf="f1['re_password'].touched && f1['re_password'].invalid" class="invalid-feedback d-block">
                            <div *ngIf="f1['re_password'].errors['confirmedValidator']">Password and Re-Enter Password must be match.</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="" class="form-label">First Name:</label>
                        <input type="text" class="form-control" formControlName="first_name">
                        <div class="invalid-feedback d-block"
                            *ngIf="f1['first_name'].errors?.['required'] && (f1['first_name'].dirty || f1['first_name'].touched)">
                            Please fill first name.
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="" class="form-label">Last Name:</label>
                        <input type="text" class="form-control" formControlName="last_name">
                        <div class="invalid-feedback d-block"
                            *ngIf="f1['last_name'].errors?.['required'] && (f1['last_name'].dirty || f1['last_name'].touched)">
                            Please fill last name.
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="" class="form-label">Date of Birth:</label>
                        <div class="input-group mb-3">
                            <input type="text" [owlDateTime]="dt1" [owlDateTimeTrigger]="dt1" formControlName="dob" form class="form-control" placeholder="DOB"
                                aria-label="DOB">
                            <div class="input-group-append d-flex" [owlDateTimeTrigger]="dt1">
                                <span class="input-group-text rounded-0"><i class="fa fa-calendar"></i></span>
                            </div>
                        </div>
                        <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
                        <div class="invalid-feedback d-block"
                            *ngIf="f1['dob'].errors?.['required'] && (f1['dob'].dirty || f1['dob'].touched)">
                            Please select dob.
                        </div>
                        <div class="invalid-feedback d-block"
                            *ngIf="f1['dob'].errors?.['futureDate'] && (f1['dob'].dirty || f1['dob'].touched)">
                            Date of birth cannot be in the future.
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="sel1" class="form-label">Country:</label>
                        <select class="form-control" formControlName="country" id="sel1">
                            <option>Select</option>
                            <ng-container  *ngFor="let country of countries">
                                <option value="{{country.code}}">{{country.name}}</option>
                            </ng-container>
                        </select>
                        <div class="invalid-feedback d-block"
                            *ngIf="f1['country'].errors?.['required'] && (f1['country'].dirty || f1['country'].touched)">
                            Please select country.
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="" class="form-label">Gym/Team Name:</label>
                        <input type="text" class="form-control" formControlName="gym_name">
                        <div class="invalid-feedback d-block"
                            *ngIf="f1['gym_name'].errors?.['required'] && (f1['gym_name'].dirty || f1['gym_name'].touched)">
                            Please fill gym name.
                        </div>
                    </div>
                    <div class="form-group">
                        <input type="checkbox" formControlName="trial" [checked]="f1['trial'].value" value="1" name="trial" id="trial">
                        <label for="trial" class="d-inline-block ms-2 form-label">Activate Trial</label>
                    </div>
                    <div class="row" *ngIf="plans && f1['trial'].value!=1">
                        <label for="" class="form-label">Purchase Plan</label>
                        <div class="col-md-6 mb-2" *ngFor="let plan of plans">
                            <div class="plan-box">
                                <div class="heading mb-3">
                                    {{plan[0].title}}
                                </div>
                                <!-- <div class="sub-heading mb-3">
                                    [NOVICE - MEDIAN]
                                </div> -->
                                    <div class="input-radios-wrap">
                                        <ng-container *ngFor="let subplan of plan">
                                            <div>
                                                <input type="radio" formControlName="plan" value="{{subplan.plan.stripe_plan_id}}" name="plan" id="plan{{subplan.index}}">
                                                <label for="plan{{subplan.index}}">{{subplan.plan.period}} ({{subplan.plan.price}} USD*)</label>
                                            </div>
                                        </ng-container>
                                    </div>
                            </div>
                        </div>
                        
                    </div>
                    <div class="invalid-feedback d-block"
                        *ngIf="f1['plan'].errors?.['required'] && (f1['plan'].dirty || f1['plan'].touched)">
                        Please select plan.
                    </div>
                    
                    <div class="d-flex justify-content-end mt-3">
                        <button type="submit" class="btn btn-gold mt-2 ml-auto">Sign Up <i *ngIf="formSubmitting" class="fa fa-spinner fa-spin"></i></button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
</div>
